"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const CulvertRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "culvertRoutineMaintenance",
    assetType: "culvert",
  });

  return { inspectionRoute };
};

module.exports = CulvertRoutes();
